module.exports = __webpack_public_path__ + "src/assets/images/template-icon2.png";